<script lang="ts" setup>
defineProps({
  classes: {
    type: String,
    default: 'w-5 h-5'
  }
});
</script>
<template>
  <Icon icon-name="Spinner" :class="[classes, 'm-auto animate-spin']" />
</template>
